import SquigglyLine12Icon from '@/assets/icons/squiggly-lines/squiggly-line-12.svg?react';
import SquigglyLine5Icon from '@/assets/icons/squiggly-lines/squiggly-line-5.svg?react';
import cardBgLinesSvg from '@/assets/images/home/card-bg-lines.svg';
import coupleLaughingImg from '@/assets/images/home/couple-laughing.png';
import { Button } from '@/components/common/Button';
import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';
import { useBreakpoint } from '@/lib/contexts/BreakpointContext';
import { routes } from '@/routes/routes';
import { StarFilled as StarFilledIcon } from '@carbon/icons-react';
import { Link } from '@tanstack/react-router';

export function TestimonialsSection() {
  const { isDesktop } = useBreakpoint();

  return (
    <Section containerClassName="bg-muted">
      <Heading
        as="h2"
        className="text-secondary mb-12.5"
        underlinedText="Don't take"
        underline={
          isDesktop ? (
            <SquigglyLine12Icon className="-bottom-4" />
          ) : (
            <SquigglyLine5Icon className="-bottom-1.5" />
          )
        }
      >
        Don't take our word for it
      </Heading>

      <div className="lg:flex lg:items-start lg:gap-12">
        <div className="lg:w-full">
          <Heading
            as="h3"
            size={isDesktop ? 'h2' : 'h3'}
            className="text-secondary mb-5 text-left"
          >
            Why choose us
          </Heading>

          <p className="lg:text-foreground lg:text-8.75 text-muted-foreground mb-11.25">
            Because your health deserves more than guesswork. Eternalife
            delivers doctor-guided supplements, personalized to your body, and
            built to evolve with you. No generic pills. No one-size-fits-all
            formulas. Just real science, real support, and results you can feel
          </p>

          {isDesktop && (
            <Button variant="secondary" asChild>
              <Link to={routes.auth.login}>Find your doctor</Link>
            </Button>
          )}
        </div>

        <div className="shrink-0 lg:flex lg:items-stretch lg:gap-5">
          <div className="flex flex-col gap-5 lg:h-133.75 lg:w-full lg:max-w-111.25">
            <div className="bg-primary text-primary-foreground flex h-full flex-col justify-center rounded-[1.125rem] p-10 lg:px-10 lg:py-0">
              <div className="mb-4.5 flex gap-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <StarFilledIcon key={i} className="size-6 text-[#FCCA60]" />
                ))}
              </div>

              <p className="mb-4.5 italic">
                I feel more focused and energized throughout the day. The
                personalized packs make it easy to stay consistent. I love
                knowing exactly what I'm taking and why.
              </p>

              <p className="leading-7.5 italic">Julian, 2025-05-08</p>
            </div>

            <div className="relative mb-7.5 h-full overflow-hidden rounded-[1.125rem] lg:mb-0">
              <img
                src={coupleLaughingImg}
                alt="Couple Laughing"
                className="absolute inset-0 object-cover"
              />
            </div>
          </div>

          <div
            className="text-secondary flex min-h-133.75 flex-col justify-between rounded-[0.6875rem] border border-black bg-cover bg-center bg-no-repeat px-8 py-13 lg:h-full lg:max-w-72.5"
            style={{
              backgroundImage: `url("${cardBgLinesSvg}")`,
              backgroundPositionX: '10%',
            }}
          >
            <div>
              <p className="text-[4.5rem] leading-22.25 font-semibold tracking-normal">
                96%+
              </p>

              <p className="pl-1.25">
                Doctors say Eternalife supplements lead to better outcomes and
                satisfied patients
              </p>
            </div>

            <div>
              <Heading asChild size="h3" className="text-left">
                <p>Telomera</p>
              </Heading>
              <p className="pl-1.25">
                Our dedicated research lab certified and accredited by EU
                General Counsil.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Section>
  );
}
